import {authHeader} from '../backend'
import {handleResponse} from './handleResponse'

export const homeService = {
  getTotalAplData,
  getClubAplData
}

function getTotalAplData () {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/home/total-apl?` + Date.now(), requestOptions).then(handleResponse)
}

function getClubAplData (ccode) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/home/club-apl?ccode=${ccode}&` + Date.now(), requestOptions).then(handleResponse)
}



// WEBPACK FOOTER //
// ./src/router/homeRouter.js